import {
  Grid,
  Theme,
  Typography,
  createStyles,
  makeStyles,
} from '@material-ui/core';
import { PENDING_INSPECTION } from 'data-layer-cr/dist/constants/quotationStatus';
import { Quotation } from 'data-layer-cr/dist/models';
import { DefaultButton, NetworkIndicator } from 'design-system';

// Hooks
import usePdfDownloader from 'src/hooks/usePdfDownloader';

// Functions
import { getQuotationCustomerName } from 'src/functions/quotationMethods';

// Components
import { CopyInspectionLinkButton } from '../../../components';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonWrapper: {
      padding: theme.spacing(2),
    },
    buttonContentWrapper: {
      display: 'inline-block',
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: 300,
      },
    },
  }),
);

type Props = {
  quotation: Quotation;
};

const QuotationDetailsButton = ({ quotation }: Props): JSX.Element => {
  const quotationUrlSalt = quotation.urlSalt;
  const classes = useStyles();
  const customerName = getQuotationCustomerName(quotation);
  const quotationPDFName = `Cotización Auto - ASSA - ${customerName}.pdf`;
  const { pdfBlob, fetchStatus } = usePdfDownloader(
    `Quotation/generatePdf?hashQuotation=${quotationUrlSalt}`,
  );

  function downloadPdf(): void {
    const pdfUrl = URL.createObjectURL(pdfBlob);
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.setAttribute('target', '_blank');
    link.setAttribute('download', quotationPDFName);
    document.body.appendChild(link);
    link.click();
  }

  const emissionUrl = `${process.env.REACT_APP_INSPECTION_URL}${quotation.urlSalt}`;

  function goToEmission(): void {
    window.open(emissionUrl, '_blank');
  }

  return (
    <div className={classes.buttonWrapper}>
      <Grid container spacing={2} alignItems="center">
        <Grid
          item
          xs={12}
          md={6}
          container
          justifyContent="flex-end"
          alignItems="center"
        >
          <div className={classes.buttonContentWrapper}>
            <NetworkIndicator
              requesting={fetchStatus === 'requesting'}
              message="Obteniendo pdf..."
            />
            {typeof pdfBlob !== 'undefined' && fetchStatus !== 'requesting' && (
              <DefaultButton
                id="sales-web-button-downloadquotation"
                data-testid="download-pdf-button"
                fullWidth
                onClick={downloadPdf}
              >
                Descargar Cotización
              </DefaultButton>
            )}
            {typeof pdfBlob === 'undefined' && fetchStatus !== 'requesting' && (
              <Grid
                data-testid="pdf-error"
                container
                alignItems="center"
                justifyContent="center"
              >
                <Typography variant="caption">
                  No se pudo obtener el pdf
                </Typography>
              </Grid>
            )}
          </div>
        </Grid>
        <Grid item xs={12} md={6} container justifyContent="flex-start">
          <div className={classes.buttonContentWrapper}>
            {quotation.status.id === PENDING_INSPECTION && (
              <CopyInspectionLinkButton
                id="sales-web-button-copylinkinspection"
                data-testid="copy-link-button"
                quotation={quotation}
              />
            )}
            {quotation.status.id !== PENDING_INSPECTION && (
              <DefaultButton
                data-testid="go-to-emission-button"
                fullWidth
                onClick={goToEmission}
                variant="outlined"
                id="sales-web-button-emissionpaypolicy"
              >
                Emitir póliza
              </DefaultButton>
            )}
          </div>
        </Grid>
      </Grid>
    </div>
  );
};
export default QuotationDetailsButton;
